/** Customer-facing copy — single source for storefront and hub UI. */

export const DEFAULT_DELIVERY_HIGHLIGHT =
  'ShopGND partners with trusted local couriers for island-wide delivery across Grenada, Carriacou, and Petite Martinique.';

export const platformCopy = {
  deliveryHighlight: DEFAULT_DELIVERY_HIGHLIGHT,
  deliveryHighlightTitle: 'Island-wide delivery',
  secureCheckout: 'Pay securely online or cash on delivery.',
  cardPayments: 'Accept card payments',
  setUpPayouts: 'Set up payouts',
  serviceFee: 'Service fee',
  classifiedsPersonal: 'Sell personal items — cars, electronics, jobs, and more.',
} as const;

let deliveryOverride: string | null = null;

export function setDeliveryHighlightOverride(copy: string | null): void {
  deliveryOverride = copy?.trim() || null;
}

export function deliveryHighlightText(): string {
  return deliveryOverride ?? platformCopy.deliveryHighlight;
}
